import { VirtualItem } from '@tanstack/react-virtual';

interface IVirtualItemWrapperProps {
  id: number;
  children: React.ReactNode;
  virtualRow: VirtualItem;
}

export const VirtualItemWrapper: React.FC<IVirtualItemWrapperProps> = ({
  id,
  children,
  virtualRow,
}) => {
  return (
    <div
      key={id}
      data-index={virtualRow.index}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: `${virtualRow.size}px`,
        transform: `translateY(${virtualRow.start}px)`,
      }}
    >
      {children}
    </div>
  );
};
